import React from 'react'
import './Explore_category.css'
import { Link } from 'react-router-dom';

const Explore_category = () => {

    const explorecategory = [
        {
            image: '/assets/images/explore/explore-category/volunteer.png',
            name: 'Volunteer in Divine Presence',
            link: '/volunteer'
        },
        {
            image: '/assets/images/explore/explore-category/latest.png',
            name: 'Explore Latest Products',
            link: '/explore-latest-products'
        },
        {
            image: '/assets/images/explore/explore-category/seva.png',
            name: 'Offer Your Seva Through Donation',
            link: '/donate'
        },
        {
            image: '/assets/images/explore/explore-category/shibir.png',
            name: 'Shibir and Event Registrations',
            link: '/event-registration'
        },
        {
            image: '/assets/images/explore/explore-category/spritual.png',
            name: 'Your Spiritual Stay',
            link: '/guest-house'
        },
        {
            image: '/assets/images/explore/explore-category/journey.png',
            name: 'Journey Through Frames',
            link: '/gallery-frames'
        },
    ];

    return (
        <>
            <section className='Explore_category_sec'>
                <div className='container'>
                    <div className='row'>
                        {explorecategory.map((data, index) => (
                            <div className='col-xl-2 col-lg-2 col-md-3 col-sm-4 col-6 mb-3'>
                                <div className='catcard'>
                                    <Link to={data.link}>
                                        <div className='img_div'>
                                            <img className='catimg' src={data.image} alt="catimg" />
                                        </div>
                                        <p className='catname'>{data.name}</p>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Explore_category